export enum UserRole {
    Admin = 1,
    Workshop = 2,
    Customer = 3,
    TicketIntegretor = 4,
    Reader = 5,
    CustomerService = 6,
    StreetTeam = 7
}